import components from './components';
import directives from './directives';
import VueTouch   from 'vue-touch';
import WindowManager from '../core/WindowManager';
import ImageManager from '../core/ImageManager';



const windowManager = new WindowManager();
const imageManager = new ImageManager();



function plugin(Vue) {
  Vue.use(VueTouch);
  // // Directives
  // Object.keys(directives).forEach(key => {
  //   const directive = directives[key];
  //   Vue.directive(directive.name, directive);
  // });

  // Components
  Object.keys(components).forEach(key => {
    const component = components[key];
    Vue.component(component.name, component);
  });

  function blurActiveElement() {
    if (document.activeElement && document.activeElement.blur) {
      document.activeElement.blur();
    }
  }

  Vue.prototype.$bcb = {
    blurActiveElement: blurActiveElement,
  };

  Vue.prototype.$window = windowManager;
  // Vue.prototype.$image = imageManager;

  Vue.prototype.$nextTickPromise = function() {
    return new Promise(resolve => {
      this.$nextTick(resolve);
    });
  }
}



export default plugin;


// WEBPACK FOOTER //
// ./src/shared/bc-banner/plugin.js